import config from "../../config";
import Request from "../Request";

export default function logout(onSuccess, onFailure) {
  Request.delete(`${config.legacyApiUrl}/logout`, onSuccess, onFailure);
}